import { Flex, Link } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';

import SituacaoJuridicaService from "../../../main/services/SituacaoJuridicaService";
import Tabela from '../../components/Tabela';
import { Link as ReactLink } from 'react-router-dom';
import { isEmptyArray } from "formik";
import Loading from "../../components/Loading";
import { useAuthProvider } from '../../../Context/AuthProvider';

const ListaSituacaoJuridica = () => {

    document.title = 'MCA - Situação Jurídica'

    const _IsMounted = useRef(false);
    const { roleKeycloack } = useAuthProvider();
    const [columns] = useState([
        {
            Header: 'Descrição',
            accessor: 'descricao',
            width: 70,
            Cell: (props) => {

                const id = props.row.original.id;
                var descricao = props.value;

                if (descricao.length > 100) {
                    descricao = descricao.substring(0, 100) + "..."
                }
                return <Link title={props.value} as={ReactLink} to={"/situacao-juridica/" + id}>{descricao}</Link>
            }
        },
        {
            Header: 'Tipo',
            accessor: 'tipo',
            Cell: (props) => {
                let retorno = "";
                props.value === "P" ? (
                    retorno = <span>Processo</span>
                ) : (
                    retorno = <span>Procedimento</span>
                )
                return retorno;
            }
        },
        {
            Header: 'Data Início',
            accessor: 'dataInicio',
            Cell: (props) => {
                const custom_date = new Date(props.value).toLocaleDateString("pt-BR")
                return <span>{custom_date}</span>
            }
        },
        {
            Header: 'Data de término',
            accessor: 'dataFim',
            // disableSortBy: true,
            Cell: (props) => {
                if (props.value) {
                    const custom_date = new Date(props.value).toLocaleDateString("pt-BR")
                    return <span>{custom_date}</span>
                }
                return <span />

            }
        },

    ])
    const [data, setData] = useState([]);
    const [fixedData, setFixedData] = useState([]);
    const [filter] = useState('');
    const [loading, setLoading] = useState(true);
    const [nullData, setNullData] = useState(true)

    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getTipoPrograma() {
        return SituacaoJuridicaService.listarSituacaoJuridica();
    }

    function fetchData(state) {

        getTipoPrograma()
            .then(res => {
                if (!isEmptyArray(res.data)) {
                    setNullData(false)
                }
                setData(res.data)
                setFixedData(res.data)
                setLoading(false)

            }).catch((error) => {
                console.warn(error)
            })
    }


    return (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >

            <Flex
                w="100%"
            >

            </Flex>
            {loading ? (
                <Loading />
            ) : (
                <Flex>
                    <Tabela
                        data={data}
                        loading={loading}
                        columns={columns}
                        setLoading={setLoading}
                        filter={filter}
                        setData={setData}
                        dataNull={nullData}
                        fixedData={fixedData}
                        placeholderFilter="Pesquise pela Situação Jurídica"
                        entidade="situacao-juridica"
                        roleKeycloack={roleKeycloack}
                    />
                </Flex>
            )}

        </Flex>
    )
}

export default ListaSituacaoJuridica;